export default function ButtonPrimary({label,clickEvent}){
    
    return(
        <div className="modal-btn-primary" onClick={clickEvent}>{label}</div>
    )

}